import { BehaviorSubject } from 'rxjs';
import { AppMessages } from 'app/shared/consts/app-messages';
import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { BarcodeFormat } from '@zxing/library';

@Component({
  selector: 'qr-scanner',
  templateUrl: './qr-scanner.component.html',
  styleUrls: ['./qr-scanner.component.scss'],
})
export class QrScannerComponent implements OnInit {

  public showMessageBox: boolean = false;
  public message: string = '';
  public placeHolder: string = '- - - - - -';

  @Input() 
  public codeLen: number = 6;

  @Input() 
  public displayCode: boolean = true;

  // Event handler
  @Output()
  public offScanner = new EventEmitter();
  @Output()
  public qrSuccess = new EventEmitter<string>();

  @Output()
  public qrLoyaltyEvent = new EventEmitter<string>();


  public availableDevices: MediaDeviceInfo[];
  public deviceCurrent: MediaDeviceInfo = null;
  public deviceSelected: string;
  public hasDevices: boolean;
  public hasPermission: boolean;
  public qrResultString: string = "";
  public torchEnabled = false;
  public torchAvailable$ = new BehaviorSubject<boolean>(false);
  public formatsEnabled: BarcodeFormat[] = [
    BarcodeFormat.QR_CODE,
  ];

  private submitedFlg: boolean = false;
  constructor() { }

  ngOnInit() {
    var agent = navigator.userAgent.toLocaleLowerCase();
    if(this.isInvalidBrowser(agent))
    {
      return;
    }
    this.qrResultString = "";
    this.submitedFlg = false;
    this.placeHolder = '';
    for(var i = 0; i< this.codeLen ;i ++)
    {
      this.placeHolder = this.placeHolder + '- ';
    }
    this.placeHolder = this.placeHolder.trim();
  }

  private isInvalidBrowser(userAgent: string)
  {
    userAgent = userAgent.toLocaleLowerCase();
    if(userAgent && userAgent.indexOf('zalo') != -1)
    {
      this.showMessageBox = true;
      this.message = AppMessages.ZALO_BROWSER_ERROR;
      return true;
    }

    if((userAgent.indexOf("fban") > -1) || (userAgent.indexOf("fbav") > -1))
    {
      this.showMessageBox = true;
      this.message = AppMessages.FB_BROWSER_ERROR;
      return true;
    }
    return false;
  }

  public closeMessagePopupEvent()
  {
    this.showMessageBox = false;
  }

  public closeScanner()
  {
    this.offScanner.emit("CLOSE");
  }


  onCamerasFound(devices: MediaDeviceInfo[]): void {
    this.availableDevices = devices;
    this.hasDevices = Boolean(devices && devices.length);
  }

  onCodeResult(resultString: string) {
    // Check when OR from Loyalty
    let pattern = /^https.+\/qr\/[0-9a-z]{32}$/g;
    if(pattern.test(resultString))
    {
      const strLen = resultString.length;
      const res = resultString.substring(strLen - 32);
      this.qrLoyaltyEvent.emit(res);
    }
    else
    {
      this.qrResultString = resultString.substr(-1 * this.codeLen);
      this.qrSuccess.emit(resultString);
    }
  }

  onDeviceSelectChange(selected: string) {
    const selectedStr = selected || '';
    if (this.deviceSelected === selectedStr) { return; }
    this.deviceSelected = selectedStr;
    const device = this.availableDevices.find(x => x.deviceId === selected);
    this.deviceCurrent = device || undefined;
  }

  onDeviceChange(device: MediaDeviceInfo) {
    const selectedStr = device.deviceId || '';
    if (this.deviceSelected === selectedStr) { return; }
    this.deviceSelected = selectedStr;
    this.deviceCurrent = device || undefined;
  }

  onHasPermission(has: boolean) {
    this.hasPermission = has;
  }

  onTorchCompatible(isCompatible: boolean): void {
    this.torchAvailable$.next(isCompatible || false);
  }

  toggleTorch(): void {
    this.torchEnabled = !this.torchEnabled;
  }

  enterBarcodeChange(evt:any)
  {
    if(!this.qrResultString || this.qrResultString.length < this.codeLen)
    {
      return;
    }
    var temp = this.qrResultString;
    var base = this;
    setTimeout(function(){
      if(base.qrResultString && temp == base.qrResultString && !base.submitedFlg)
      {
        base.submitedFlg = true;
        base.qrSuccess.emit(temp.toUpperCase());
      }
    },500);
  }

  codeKeyPress(evt:any)
  {
    var charCode = evt.keyCode;
    if ((charCode > 64 && charCode < 91) || (charCode > 96 && charCode < 123) || charCode == 8 || (charCode >= 48 && charCode <= 57))
        return true;
    else
        return false;
    }
}
